import numeral from 'numeral';
import React from 'react';

import './RecurringReviewFund.scss';

import If from '../../Shared/If/If';
import ToolTip from '../../Shared/ToolTip/ToolTip';
import { ordinal, getMonthName } from '../../../utils/dates/date-utility';
import {
  replaceSpecialCharacterWith,
  replaceSpecialCharacterWithSpace,
} from '../../../utils/shoppingCart/shopping-cart-utility';
import { PRODUCT_TYPE_LABEL_MAP } from '../../../settings/settings';
import { isProductType529 } from '../../../utils/funds/funds-utility';
import { TOOLTIP_POSITION_BOTTOM } from '../../../utils/dom-utils';
import { isAPP, isRAS } from '../../../utils/advice/advice-utility';

const START_DATE_TOOLTIP =
  'Automatic Buy programs are typically established the following business day, but can take up to three business days to be completed. Choosing an Automatic Buy date within 3 business days of today’s date may cause your first transaction to occur at the next instance of the chosen date.';

function RecurringReviewFund({ fund }) {
  const displayClassification = replaceSpecialCharacterWith(
    fund.displayClassification,
    '-'
  ).toUpperCase();
  const agreementType = replaceSpecialCharacterWithSpace(
    fund.agreementType
  ).toUpperCase();
  const agreementStyleName = fund.newFund ? 'new-agreement-number' : 'user';
  const displayPlanType = isProductType529(fund.productType)
    ? PRODUCT_TYPE_LABEL_MAP[fund.productType]
    : `${displayClassification} / ${agreementType}`;
  return (
    <div className="recurring-review-fund-container">
      <div className="recurring-review-fund-selectedFunds e2e-recurring-review-fund">
        <div className="recurring-review-fund-selectedFunds-inner">
          <div className="recurring-review-fund-phone-label">To:</div>
          <div className="recurring-review-fund-spacer">
            <div className="recurring-review-fund-group">{displayPlanType}</div>
            <div className="recurring-review-fund-fundName">
              {fund.fundName}{' '}
              {!isAPP(fund.productType) && !isRAS(fund.productType) && (
                <span className="recurring-review-fund-ticker">
                  {fund.ticker}
                </span>
              )}
            </div>

            <div className="recurring-review-fund-details">
              <span
                className={`blocked_data text-nowrap recurring-review-fund-${agreementStyleName}`}
              >
                {fund.newFund ? 'Just Added' : fund.agreementNumber}
              </span>
              <span
                className="blocked_data recurring-review-fund-user"
                title={fund.formattedEntityNames}
              >
                {fund.formattedEntityNames}
              </span>
            </div>
          </div>
        </div>
        <div className="recurring-review-fund-col">
          <div className="recurring-review-fund-phone-label">Amount:</div>
          <div>{numeral(fund.amount || 0).format('$0,0.00')}</div>
        </div>
        <div className="recurring-review-fund-freq-col">
          <div className="recurring-review-fund-phone-label">Frequency:</div>
          <div className="recurring-review-fund-month-container">
            Every{' '}
            {fund.transferMonths.length === 12 && (
              <div className="recurring-review-fund-month-review">month</div>
            )}
            {fund.transferMonths.length !== 12 &&
              fund.transferMonths
                .sort((a, b) => a.value - b.value)
                .map((month, index) => (
                  <div
                    className="recurring-review-fund-month-review"
                    key={index}
                  >
                    {index > 0 &&
                      index < fund.transferMonths.length - 1 &&
                      ', '}
                    {index === fund.transferMonths.length - 1 &&
                      index > 0 &&
                      ' & '}
                    {getMonthName(month.label)}
                  </div>
                ))}
          </div>
          <div className="recurring-review-fund-day-container">
            {' '}
            on the{' '}
            {fund.transferDays
              .sort((a, b) => a.value - b.value)
              .map((day, index) => (
                <div className="recurring-review-fund-day-review" key={index}>
                  {index > 0 && index < fund.transferDays.length - 1 && ', '}
                  {index === fund.transferDays.length - 1 && index > 0 && ' & '}
                  {ordinal(day.value)}
                </div>
              ))}
          </div>
        </div>
        <div
          className={
            fund.startDate
              ? 'recurring-review-fund-date-col'
              : 'recurring-review-fund-hidden'
          }
        >
          <div className="recurring-review-fund-phone-label">
            EST. Start Date
            <ToolTip
              message={START_DATE_TOOLTIP}
              placement={TOOLTIP_POSITION_BOTTOM}
            />
          </div>
          {fund.startDate}
        </div>
      </div>
      <If test={fund.moneyMarketReformMessage}>
        <div
          className="recurring-review-fund-mmr-event-message"
          dangerouslySetInnerHTML={{ __html: fund.moneyMarketReformMessage }}
        />
      </If>
    </div>
  );
}

export default RecurringReviewFund;
